"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePremiumSupport = void 0;
var usePremiumSupport_1 = require("./usePremiumSupport");
Object.defineProperty(exports, "usePremiumSupport", { enumerable: true, get: function () { return usePremiumSupport_1.usePremiumSupport; } });
